module.exports = __webpack_public_path__ + "static/media/delivery-truck.224678b8.png";